module.exports = __webpack_public_path__ + "img/alfie-a2.486e31f5.png";